import React, { useEffect, useState } from "react";
import { ThirdWorkTreeAPI } from "../services/api";

interface Props {
  workNo: number | null;
}

/* interface WorkDetails {
  workNo: number;
  work?: string;
  description?: string;
  procedure?: string;
  activity?: number;

  unit?: string;
  quantity?: number;
  unitRate?: number;
  cost?: number;

  track?: number;
  trackBy?: number;

  subcontractor?: number;
  subContractRate?: number;

  client?: number;
  clientRate?: number;

  startDate?: string;
  endDate?: string;
  duration?: number;
} */

  interface WorkDetails {
  workNo: number;

  work?: string;
  constructionMethod?: string;
  mark?: string;

  trackBy?: string;
  quickMeasure?: number;

  unitName?: string;
  quantity?: number;

  unitRate?: number;
  netCost?: number;

  subContractorName?: string;
  subContractRate?: number;

  clientName?: string;
  clientRate?: number;

  startDate?: string;
  endDate?: string;
  duration?: number;

  description?: string;
}

const rowStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "45% 55%",
  borderBottom: "1px solid #e5e7eb",
  minHeight: 26,
};

const WorkDetailsPanel: React.FC<Props> = ({
  workNo,
}) => {
  const [data, setData] =
    useState<WorkDetails | null>(null);

  useEffect(() => {
    if (!workNo) {
      setData(null);
      return;
    }

    ThirdWorkTreeAPI.getWorkDetails(workNo)
      .then(setData)
      .catch(console.error);
  }, [workNo]);

  if (!workNo) {
    return (
      <div className="p-3 text-gray-500">
        Select a Work
      </div>
    );
  }

  if (!data) {
    return (
      <div className="p-3">
        Loading...
      </div>
    );
  }

  return (
    <div className="h-full overflow-auto bg-white text-sm">
      {/* Definition */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b">
        Definition
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">Work</div>
        <div className="px-2 py-1 font-semibold">
          {data.work}
        </div>
      </div>

      

      {/* <div style={rowStyle}>
        <div className="px-2 py-1">
          Procedure
        </div>
        <div className="px-2 py-1">
          {data.procedure}
        </div>
      </div> */}
      <div style={rowStyle}>
  <div className="px-2 py-1">
    Construction Method
  </div>
  <div className="px-2 py-1">
    {data.constructionMethod}
  </div>
</div>

<div style={rowStyle}>
  <div className="px-2 py-1">
    Mark
  </div>
  <div className="px-2 py-1">
    {data.mark}
  </div>
</div>

      {/* Measurements */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b mt-2">
        Measurements & Rates
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Track By
        </div>
        <div className="px-2 py-1">
          {data.trackBy}
        </div>
      </div>
      <div style={rowStyle}>
  <div className="px-2 py-1">
    Quick Measure
  </div>
  <div className="px-2 py-1">
    {data.quickMeasure}
  </div>
</div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Unit
        </div>
        <div className="px-2 py-1 font-semibold">
        {/*  {data.unit} */}
        {data.unitName}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Quantity
        </div>
        <div className="px-2 py-1">
          {data.quantity}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Unit Rate
        </div>
        <div className="px-2 py-1">
          {data.unitRate}
        </div>
      </div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Cost
        </div>
        <div className="px-2 py-1">
          {/*{data.cost}*/}
          {data.netCost}
        </div>
      </div>
      <div style={rowStyle}>
  <div className="px-2 py-1">
    Sub Contractor
  </div>
  <div className="px-2 py-1">
    {data.subContractorName}
  </div>
</div>

<div style={rowStyle}>
  <div className="px-2 py-1">
    Sub Contract Rate
  </div>
  <div className="px-2 py-1">
    {data.subContractRate}
  </div>
</div>

<div style={rowStyle}>
  <div className="px-2 py-1">
    Client
  </div>
  <div className="px-2 py-1">
    {data.clientName}
  </div>
</div>

<div style={rowStyle}>
  <div className="px-2 py-1">
    Client Rate
  </div>
  <div className="px-2 py-1">
    {data.clientRate}
  </div>
</div>
      {/* Scheduling */}
      <div className="bg-gray-100 px-2 py-1 font-semibold border-b mt-2">
        Scheduling & Tracking
      </div>

      {/* <div style={rowStyle}>
        <div className="px-2 py-1">
          Start Date
        </div>
        <div className="px-2 py-1">
          {data.startDate}
        </div>
      </div> */}

      <div style={rowStyle}>
  <div className="px-2 py-1">
    Start Date
  </div>
  <div className="px-2 py-1">
    {data.startDate
      ? new Date(data.startDate).toLocaleDateString("en-GB")
      : ""}
  </div>
</div>

     {/*  <div style={rowStyle}>
        <div className="px-2 py-1">
          End Date
        </div>
        <div className="px-2 py-1">
          {data.endDate}
        </div>
      </div> */}
      <div style={rowStyle}>
  <div className="px-2 py-1">
    End Date
  </div>
  <div className="px-2 py-1">
    {data.endDate
      ? new Date(data.endDate).toLocaleDateString("en-GB")
      : ""}
  </div>
</div>

      <div style={rowStyle}>
        <div className="px-2 py-1">
          Duration
        </div>
        <div className="px-2 py-1">
          {data.duration}
        </div>
      </div>
    </div>
  );
};

export default WorkDetailsPanel;